/**
 * 지도 API DTO → `src/data/exploreMap.ts` ExploreMapListItem
 */

import type { ExploreMapSpaceListItemDto } from '../schemas/exploreMap';
import type { ExploreMapListItem } from '../exploreMap';

export function exploreMapListItemFromDto(row: ExploreMapSpaceListItemDto): ExploreMapListItem {
  const [a, b] = row.tags ?? [];
  const latitude = row.latitude ?? row.lat;
  const longitude = row.longitude ?? row.lng;
  return {
    availableRoomCount: row.availableRoomCount,
    bookmarkSaved: row.bookmarkSaved,
    detailPath: row.detailPath || '#',
    image: row.imageUrl || '',
    latitude: typeof latitude === 'number' && Number.isFinite(latitude) ? latitude : undefined,
    location: row.location || '',
    longitude: typeof longitude === 'number' && Number.isFinite(longitude) ? longitude : undefined,
    priceLabel: row.priceLabel || '',
    priceSuffix: row.priceSuffix || '',
    rating: row.rating || '',
    spaceType: row.spaceType || '',
    studio: row.studio || '',
    title: row.title || '',
    tags: [a ?? '', b ?? ''] as [string, string],
  };
}
